import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=70bff6f2&scoped=true&"
import script from "./photo.vue?vue&type=script&lang=js&"
export * from "./photo.vue?vue&type=script&lang=js&"
import style0 from "./photo.vue?vue&type=style&index=0&id=70bff6f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bff6f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bff6f2')) {
      api.createRecord('70bff6f2', component.options)
    } else {
      api.reload('70bff6f2', component.options)
    }
    module.hot.accept("./photo.vue?vue&type=template&id=70bff6f2&scoped=true&", function () {
      api.rerender('70bff6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/execute/display_task/table/photo/photo.vue"
export default component.exports